import useGlobalProvider from "../../../lib/providers/globalProvider";
import { useState } from "react";
import { useLoculi } from "../../../lib/hooks/api/loculi";
import AsyncSelectField from "../FormFields/AsyncSelectField";
import validator from "validator/es";

function LoculoSearchField({
  field,
  handleOnChange,
  isSingleSelect,
  isClearable = true,
  compressed = false,
  fullWidth = false,
  helpText = null,
  additionalQuery = {},
}) {
  const { currentComuneId } = useGlobalProvider();
  const [searchQuery, setSearchQuery] = useState({});
  const { loculi, isFetching, isLoading } = useLoculi(
    currentComuneId,
    {
      page: 0,
      pageSize: 20,
      query: { ...searchQuery, ...additionalQuery },
      sort: {},
    },
    false
  );

  const handleSearchChange = (searchValue) => {
    setSearchQuery(
      validator.isMongoId(searchValue)
        ? {
            _id: searchValue,
          }
        : {}
    );
  };

  return (
    <AsyncSelectField
      field={field}
      isSingleSelect={isSingleSelect}
      handleOnChange={handleOnChange}
      handleSearchChange={handleSearchChange}
      options={loculi.data.map((loculo) => ({
        code: loculo._id,
        label: `${loculo._id}`,
      }))}
      isLoading={isLoading || isFetching}
      isClearable={isClearable}
      compressed={compressed}
      fullWidth={fullWidth}
      helpText={helpText}
    />
  );
}

export default LoculoSearchField;
